export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_complete_3.346d61a3.jpg";